var _path, _g, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.121 23H7.37666C5.51197 23 4 21.5012 4 19.6527V4.34732C4 2.49883 5.51197 1 7.37666 1H15.8418L20.5 5.63869V19.6527C20.5 21.5012 18.988 23 17.1233 23H17.121Z",
    fill: "#00AB54"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4976 5.63869H16.7988C16.2745 5.63869 15.8489 5.21911 15.8489 4.6993L15.8418 1",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2334 17.6552L9.66713 14.0747L11.7999 16.2985L14.4147 11.5806L17.5703 17.6552H7.2334Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64406 12.1771C9.05963 12.1771 9.39652 11.8432 9.39652 11.4312C9.39652 11.0193 9.05963 10.6853 8.64406 10.6853C8.22849 10.6853 7.8916 11.0193 7.8916 11.4312C7.8916 11.8432 8.22849 12.1771 8.64406 12.1771Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.ec0f83cff06aa870626150b4055c4cb0.svg";
export { ForwardRef as ReactComponent };